import {FC, useState} from "react";
import {Event} from '../../types/domain.ts';
import {Flex, Image, Tooltip, Typography} from "antd";
import {CameraOutlined} from "@ant-design/icons";

type Props = {
    event: Event;
}

export const EventNameCell: FC<Props> = ({ event }) => {
    const [previewImage, setPreviewImage] = useState<string>();

    const innerContent = (
        <Flex gap={8}>
            <Typography.Text delete={event.cancelled}>{event.name}</Typography.Text>
            {event.cancelled && <Typography.Text>(отменено)</Typography.Text>}
            {event.image && <CameraOutlined onClick={() => setPreviewImage(event.image!.url)}/>}
            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: Boolean(previewImage),
                        onVisibleChange: () => setPreviewImage(undefined),
                    }}
                    src={previewImage}
                />
            )}
        </Flex>
    );

    if(event.description) {
        return (
            <Tooltip title={event.description.length > 500 ? event.description.slice(0, 500) + '...' : event.description}>
                {innerContent}
            </Tooltip>
        )
    }

    return innerContent;
}